import { render, staticRenderFns } from "./Bangbangbaoxiu.vue?vue&type=template&id=6d8bb3d4&scoped=true&"
import script from "./Bangbangbaoxiu.vue?vue&type=script&lang=js&"
export * from "./Bangbangbaoxiu.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangbaoxiu.vue?vue&type=style&index=0&id=6d8bb3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8bb3d4",
  null
  
)

export default component.exports